import type { ReactElement } from 'react';

const FEATURE_PILLS = [
  { icon: '⚡', label: 'Real-time lines' },
  { icon: '🎯', label: 'AI scoring' },
  { icon: '📊', label: 'Live tracking' },
  { icon: '🏆', label: 'Leaderboard' },
] as const;

export function AuthPageHero(): ReactElement {
  return (
    <div className="space-y-6 text-center lg:text-left">
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-theme-primary/10 border border-theme-primary/20">
        <span className="w-2 h-2 rounded-full bg-theme-accent animate-pulse" />
        <span className="text-xs font-medium text-theme-primary">AI-Powered Analysis</span>
      </div>

      <h2 className="font-bold text-white text-2xl sm:text-4xl lg:text-6xl leading-tight">
        Smarter Bets, <span className="text-theme-primary">Better Edge</span>
      </h2>

      <p className="text-theme-text-secondary text-base sm:text-lg leading-relaxed">
        AI analyzes real sportsbook lines, player stats, and game context to surface the
        highest-value basketball props. Track every bet, see what hits, and refine your strategy.
      </p>

      <div className="hidden sm:flex flex-wrap justify-center lg:justify-start gap-2 pt-2">
        {FEATURE_PILLS.map((pill) => (
          <span
            key={pill.label}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-theme-surface border border-theme-border/50 text-sm text-theme-text-secondary"
          >
            <span>{pill.icon}</span>
            {pill.label}
          </span>
        ))}
      </div>

      <div className="hidden sm:flex justify-center lg:justify-start gap-8 pt-4">
        <div>
          <p className="text-2xl font-bold text-white">500+</p>
          <p className="text-xs text-theme-text-tertiary">Picks analyzed</p>
        </div>
        <div>
          <p className="text-2xl font-bold text-white">24/7</p>
          <p className="text-xs text-theme-text-tertiary">Live lines</p>
        </div>
        <div>
          <p className="text-2xl font-bold text-theme-accent">Free</p>
          <p className="text-xs text-theme-text-tertiary">To start</p>
        </div>
      </div>
    </div>
  );
}
